export const SUPPORT_PANNEL_MAX_WIDTH = 838;

export const SUPPORT_PANNEL_MAX_HEIGHT = 554;

export const LEFT_COLUMN_WIDTH_PERCENT = `${
  (334 / SUPPORT_PANNEL_MAX_WIDTH) * 100
}%`;

/*
 * 1280  150% zoom in view point width
 */
const ZOOM_IN_ONE_POINT_FIVE_VW = 852;

const ZOOM_IN_ONE_POINT_FIVE_SUPPORT_PANNEL_WIDTH = 719;

export const SUPPORT_PANNEL_VW_WIDTH =
  (ZOOM_IN_ONE_POINT_FIVE_SUPPORT_PANNEL_WIDTH * 100) /
  ZOOM_IN_ONE_POINT_FIVE_VW;

export const ONE_COLUMN_MAX_WIDTH = 640;
